import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-magic-uses-animal',
  templateUrl: './magic-uses-animal.component.html',
  styleUrls: ['./magic-uses-animal.component.css']
})
export class MagicUsesAnimalComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
